var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgrammeInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pie-chart_7_",
    "data-name": "pie-chart (7)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.481,
    height: 35.481,
    viewBox: "0 0 35.481 35.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50300",
    "data-name": "Group 50300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50299",
    "data-name": "Group 50299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52746",
    "data-name": "Path 52746",
    d: "M19.311,0A19.3,19.3,0,0,0,0,19.311a1.04,1.04,0,0,0,1.04,1.04H19.311a1.04,1.04,0,0,0,1.04-1.04V1.04A1.04,1.04,0,0,0,19.311,0Z",
    fill: "#3db6fb"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50302",
    "data-name": "Group 50302",
    transform: "translate(3.803 22.819)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50301",
    "data-name": "Group 50301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52747",
    "data-name": "Path 52747",
    d: "M62.978,329.827a1.04,1.04,0,0,0-.912-.541H55.912a1.04,1.04,0,0,0-.993,1.352,16.213,16.213,0,0,0,14.421,11.31v-7.8A8.44,8.44,0,0,1,62.978,329.827Z",
    transform: "translate(-54.872 -329.286)",
    fill: "#3db6fb"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50304",
    "data-name": "Group 50304",
    transform: "translate(22.819 3.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50303",
    "data-name": "Group 50303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52748",
    "data-name": "Path 52748",
    d: "M330.638,54.921a1.04,1.04,0,0,0-1.352.993v6.153a1.04,1.04,0,0,0,.541.912,8.44,8.44,0,0,1,4.322,6.362h7.8A16.213,16.213,0,0,0,330.638,54.921Z",
    transform: "translate(-329.286 -54.874)",
    fill: "#3db6fb"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_50306",
    "data-name": "Group 50306",
    transform: "translate(20.352 20.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50305",
    "data-name": "Group 50305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52749",
    "data-name": "Path 52749",
    d: "M301.011,293.678a8.453,8.453,0,0,1-7.332,7.332v7.8a16.191,16.191,0,0,0,15.129-15.129Z",
    transform: "translate(-293.679 -293.678)",
    fill: "#3db6fb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammeInsights);
export default __webpack_public_path__ + "static/media/Programme Insights.6818098c32cdbb27243db4813b282d1b.svg";
export { ForwardRef as ReactComponent };